export default __webpack_public_path__ + "static/media/phonehand.27766488.svg";